<div class="features-section">
  <div class="features-header">
    <p class="overview-label">Everything Your Books Need</p>
    <h2 class="features-heading">Built for <span class="features-heading-underline">complete control</span></h2>
    <p class="features-subtitle">
      From the first ledger to the last audit trail — every tool your finance team
      touches, in one connected system.
    </p>
  </div>

  <div class="feature-rows">
    <div class="app-row" *ngFor="let feature of features; let i = index" [class.app-row--reverse]="i % 2 === 1">
      <div class="app-row-visual">
        <span class="app-row-index">{{ i + 1 }}</span>
        <div class="app-row-frame">
          <img [src]="feature.image" [alt]="feature.title" />
        </div>
      </div>
      <div class="app-row-body">
        <h3 class="app-row-title">{{ feature.title }}</h3>
        <ul class="app-row-points">
          <li *ngFor="let point of feature.points">{{ point }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
